var map = {
	"./freshGrass_box.png": 9289,
	"./freshGrass_mini_close_side.png": 7368,
	"./freshGrass_mini_close_straight.png": 6639,
	"./freshGrass_mini_open_side.png": 6898,
	"./freshGrass_mini_open_straight.png": 5833,
	"./freshGrass_standard_close_side.png": 7106,
	"./freshGrass_standard_close_straight.png": 6729,
	"./freshGrass_standard_open_side.png": 7996,
	"./freshGrass_standard_open_straight.png": 2427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7873;